import React from 'react';

import { RouteNotFound } from '~/components/RouteNotFound';
import { EHttpStatus } from '~/domain/EHttpStatus';
import { ResponseError } from '~/domain/ResponseError';

import { GenericErrorDialog } from './GenericErrorDialog';
import { GenericErrorPage } from './GenericErrorPage';

interface IGenericError {
  error: Error | ResponseError;
  dialog?: boolean;
  onClose?: () => void;
}

export const GenericError: React.FC<IGenericError> = (props) => {
  const { error, dialog, onClose } = props;

  if (dialog) {
    return <GenericErrorDialog error={error} onClose={onClose} />;
  }

  if ((error as ResponseError).status === EHttpStatus.NotFound) {
    return <RouteNotFound />;
  }

  return <GenericErrorPage error={error} />;
};
